import React from 'react'
import {useTranslation} from 'react-i18next'
import {Divider, Typography} from 'antd'

import {withTitle} from '@/router/utils'
import {TimeZone, TwoFA, DefaultMerchant} from './components'
import styles from './styles.scss'

export const ProfileStoreSymbol = Symbol('ProfileStore')

const Profile = () => {
    const {t} = useTranslation()
    return (
        <div className={styles.root}>
            <Typography.Title level={3}>{t('Profile.title')}</Typography.Title>

            <Divider />

            <TimeZone />

            <Divider />

            <TwoFA />

            <Divider />

            <DefaultMerchant />
        </div>
    )
}

export default withTitle(Profile)
